import { Collapse } from '@mui/material';
import React, { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
    collapse: boolean;
    showing: boolean;
}>;

export default function ConditionalCollapse({ children, collapse, showing }: Props) {
    if (!collapse) {
        return (
            <>
                {children}
            </>
        );
    }

    return (
        <Collapse in={showing}>
            {children}
        </Collapse>
    );
}
